import clsx from "clsx";
import { ReactNode } from "react";

interface StepFlowNavigationProps {
  className?: string;
  primaryButton: ReactNode;
  secondaryButton?: ReactNode;
}

/**
 * Button area at the bottom of a step: stacked and full width on mobile, right-aligned in one row from tablet up.
 */
export const StepFlowNavigation = ({
  className,
  primaryButton,
  secondaryButton,
}: StepFlowNavigationProps) => (
  <div
    className={clsx(
      "flex w-full flex-col-reverse gap-4 tablet:flex-row tablet:justify-end [&>div>button]:w-full tablet:[&>div>button]:w-auto [&>div]:w-full tablet:[&>div]:w-auto",
      className,
    )}
  >
    {secondaryButton}
    {primaryButton}
  </div>
);
